import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './AnalysisModal.css';
import Lottie from "lottie-react";

function AnalysisModal({ isOpen, onClose, isUpdating }) {
    const { t: tDatabase } = useTranslation('database');

    // Fechar automaticamente quando isUpdating for false
    useEffect(() => {
        if (isOpen && !isUpdating) {
            const timer = setTimeout(() => {
                onClose();
            }, 2000); // tempo para fechar o modal

            return () => clearTimeout(timer);
        }
    }, [isUpdating, isOpen, onClose]);

    if (!isOpen) return null;

    // Fecha ao clicar fora
    const handleClickOutside = (event) => {
        if (event.target.classList.contains('modal-overlay-analysis')) {
            onClose();
        }
    };

    return (
        <div className='modal-overlay-analysis' onClick={handleClickOutside}>
            <div className='modal-content-analysis'>

                <p className='analysis-subtitle'>
                    {tDatabase('analysis_subtitle')}
                </p>

                <div className={isUpdating ? 'analysis-animation' : 'analysis-content'}>
                    <p>{tDatabase('analysis_info')}</p>
                </div>

            </div>
        </div>
    );
}

export default AnalysisModal;
